import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { tap } from "rxjs/operators";
import { DigestService, TenantService, UserService } from "../services";

@Component({
    styles: [`
        .mainPane {
            height: calc(100vh - 130px);
            overflow-y: auto;
        }
    `],
    template: `
        <mat-toolbar>
            <h2 fxFlex>Subscription</h2>
        </mat-toolbar>
        <div class="mainPane">
            <h4 style="padding-left: 20px;">Go to <a target="_blank" [routerLink]="['/browse']">Briefing Center</a></h4>

            <mat-tab-group #tabGroup (selectedIndexChange)="iframeNoTouching = true">
                <mat-tab label = "Briefing Commentary">
                    <mat-toolbar>
                        <span fxFlex></span>
                        <button *ngIf="!isEditing" mat-raised-button color="primary" (click)="startEditing()">Edit</button>
                        <div fxFlex="180px" *ngIf="isEditing" fxLayoutAlign="end center">
                            <button mat-raised-button color="primary" (click)="save()" [disabled]="isUnchanged()">Save</button>
                            <button  fxFlexOffset="20px" mat-raised-button (click)="isEditing = false">Cancel</button>
                        </div>
                    </mat-toolbar>
                    <div fxLayout="column" style="padding: 0 20px;">
                        <p>Inserts allow content to be dynamically inserted into Briefing Center emails.</p>
                        <div fxFlex="100" *ngIf="!isEditing" layout="row">
                            <div [innerHtml]="digestCommentary | safeHtml" style="border: 1px solid; padding-left: 20px;"></div>
                        </div>
                        <div *ngIf="isEditing" style="padding-top: 20px">
                            <attensa-editor fxFlex [formControl]="commentaryControl"></attensa-editor>    
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Briefing Preview">
                    <div fxFlex fxLayout="column" style="padding-top: 20px;" fxLayoutAlign="center center">
                        <spinner *ngIf="iframeNoTouching"></spinner>
                        <iframe (load)="iframeLoaded()" 
                                width="830" 
                                height="500" 
                                seamless="seamless" 
                                [src]="previewUrl | safeUrl" 
                                frameBorder="0"></iframe>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    `
})
export class PersonalBriefingsManagerComponent implements OnInit {
    isEditing: boolean;
    commentaryControl = new FormControl();
    tenant: any;
    previewUrl: string;
    digestConfiguration: any;
    iframeNoTouching = true;

    constructor(private digestService: DigestService, private tenantService: TenantService, private userService: UserService) {}

    ngOnInit(): void {
        this.digestService.getDigestConfigurationsForUser(this.userService.getCurrentUser().id).pipe(
            tap(([digestConfiguration]) => this.digestConfiguration = digestConfiguration)
        ).subscribe(() => this.configurePreviewUrl());
        
        this.tenantService.getCurrentTenant().subscribe(tenant => this.tenant = tenant);
    }

    get digestCommentary(): string {
        return this.tenant?.digestCommentaries[0].content || '';
    }

    iframeLoaded(): void {
        this.iframeNoTouching = false;
    }

    configurePreviewUrl(): void{
        this.previewUrl = this.digestService.previewUrl(this.digestConfiguration.id, this.userService.getCurrentUser().id, '?cachebreaker=' + new Date().getTime())
    }

    startEditing(): void {
        this.commentaryControl.setValue(this.digestCommentary);
        this.isEditing = true;
    }

    save(): void {
        this.tenant.digestCommentaries[0].content = this.commentaryControl.value;
        this.tenantService.saveDigestCommentaries(this.tenant.digestCommentaries)
        .pipe(tap(() => this.isEditing = false))
        .subscribe(() => this.configurePreviewUrl());
    }

    isUnchanged(): boolean {
        return this.commentaryControl.value === this.digestCommentary;
    }
}
